(function ($) {
  Drupal.behaviors.SPP = {
    attach: function () {
      site.mpp.data = {
        category: page_data['catalog-spp'],
        categories: page_data['catalog-spp']
      };
      site.mpp.init();
    }
  };
})(jQuery);
